import APIService from '@/api'

export default class APIPayment extends APIService{

    constructor(){
        super('deposits')
    }

    async getAll() {
        var response = await this.AxiosInstance
            .get(this.ApiUrl, { params: {} })
            .catch(error => {
              console.log(error.response)
            });
        return response;
    }

    create(item) {
        return this.AxiosInstance.post(this.ApiUrl, item, {});
    }

    update(item) {
        return this.AxiosInstance.put(this.ApiUrl, item, {});
    }

    delete(item) {
        return this.AxiosInstance.delete(this.ApiUrl, { params: { id: item.ID } });
    }
}


// WEBPACK FOOTER //
// ./src/api/deposit.js